import { render, staticRenderFns } from "./brandIndex.vue?vue&type=template&id=c391374e&scoped=true&"
import script from "./brandIndex.vue?vue&type=script&lang=js&"
export * from "./brandIndex.vue?vue&type=script&lang=js&"
import style0 from "./brandIndex.vue?vue&type=style&index=0&id=c391374e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c391374e",
  null
  
)

export default component.exports